import { createApi } from "@reduxjs/toolkit/query/react";
import { CopilotConfigDto, WorkItemSummaryRequestDto, WorkItemSummaryResponseDto } from "../../models/agentCopilot";
import { apiBaseQuery } from "../helpers";

const agentCopilotApi = createApi({
  reducerPath: "agentCopilot",
  tagTypes: [],
  baseQuery: apiBaseQuery("/agentcopilot"),
  endpoints: builder => ({
    getCopilotConfig: builder.query<CopilotConfigDto, string>({
      query: copilotId => `/copilots/${copilotId}`,
    }),
    getSummary: builder.query<WorkItemSummaryResponseDto, { copilotId: string; params: WorkItemSummaryRequestDto }>({
      query: ({ copilotId, params }) => ({
        url: `/copilots/${copilotId}/workitems/summary`,
        params,
      }),
    }),
  }),
});

export const {
  useGetCopilotConfigQuery,
  useGetSummaryQuery,
} = agentCopilotApi;

export default agentCopilotApi;
